'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  font-size: 70px !important;\n  color: ', ';\n'], ['\n  display: block;\n  font-size: 70px !important;\n  color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: ', ';\n  visibility: ', ';\n  opacity: ', ';\n  background: rgba(255, 255, 255, 0.6);\n  backdrop-filter: blur(2px);\n  ', ';\n'], ['\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: ', ';\n  visibility: ', ';\n  opacity: ', ';\n  background: rgba(255, 255, 255, 0.6);\n  backdrop-filter: blur(2px);\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Styles
// Helpers


var StyledIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject, _colors.red);

var Container = _styledComponents2.default.div(_templateObject2, function (_ref) {
  var visible = _ref.visible;
  return visible ? 'auto' : 'none';
}, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'visible' : 'hidden';
}, function (_ref3) {
  var visible = _ref3.visible;
  return visible ? 1 : 0;
}, (0, _polished.transitions)('visibility .3s ease-in-out, opacity .3s ease-in-out, transform .3s ease-in-out'));

var UploaderIndicator = function UploaderIndicator(_ref4) {
  var visible = _ref4.visible;
  return _react2.default.createElement(Container, {
    visible: visible
  }, _react2.default.createElement(StyledIcon, {
    icon: 'loading2',
    spin: true
  }));
};

exports.default = UploaderIndicator;